import { GameContext } from '../../../contexts/GameContext';
import { Line } from 'rc-progress';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { useLottie } from 'lottie-react';
import React, { useContext } from 'react';
import catAnimation from '../../../assets/images/games/zdar-kids-game/cat-moving-head.json';
import coinAnimation from '../../../assets/images/games/zdar-kids-game/coin-spinning.json';

export default function ZdarKidsProgressBar() {
    const { currentStep, lastStep } = useContext(GameContext);
    const { availableGame } = useContext(ProfileContext);

    const percent = Math.floor((currentStep * 100) / lastStep);

    const getPoints = () => {
        let count = 0;
        if (availableGame?.stats) {
            Object.values(availableGame?.stats).forEach((value) => {
                // @ts-expect-error
                if (value.points) {
                    // @ts-expect-error
                    count += value.points;
                }
            });
        }
        return count;
    };
    const getBarColor = () => {
        if (currentStep <= 4) {
            return '#23ab70';
        } else if (currentStep <= 5) {
            return '#b02744';
        } else if (currentStep <= 9) {
            return '#262230';
        } else if (currentStep <= 13) {
            return '#dd449a';
        } else if (currentStep <= 23) {
            return '#23ab70';
        } else if (currentStep <= 31) {
            return '#593016';
        } else if (currentStep <= 33) {
            return '#b02744';
        } else {
            return '#23ab70';
        }
    };

    const getCatLeftOffset = () => {
        if (percent < 30) {
            return '-40px';
        } else if (percent >= 80) {
            return '140px';
        } else {
            const offset = -10 + 3 * (percent - 30);
            return offset + 'px';
        }
    };
    return (
        <React.Fragment>
            {currentStep < 39 && (
                <div className="progressbar-outer">
                    <div className="progressbar-wrapper">
                        <div className="progressbar-cat" style={{ left: getCatLeftOffset() }}>
                            <CatImage />
                        </div>
                        <div className="progressbar-coin">
                            <div className="progressbar-coin-value">{getPoints()}</div>
                            <div className="progressbar-coin-image">
                                <CoinImage />
                            </div>
                        </div>
                        <Line
                            className="progress-bar-line"
                            percent={percent}
                            strokeWidth={3}
                            strokeColor={getBarColor()}
                            trailWidth={2}
                        />
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

const CatImage = () => {
    const options = {
        animationData: catAnimation,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options);

    return View;
};

const CoinImage = () => {
    const options = {
        animationData: coinAnimation,
        loop: true,
        autoplay: true,
    };

    const { View } = useLottie(options);

    return View;
};
